
(() => {
  const notes = [...document.querySelectorAll('.retro-notes')];
  const stateKey = 'mantlefordRetroNotes';

  function rememberNotes() {
    try {
      const previous = history.state;
      history.replaceState({
        ...(previous && typeof previous === 'object' ? previous : {}),
        [stateKey]: notes.filter(note => note.open).map(note => note.id)
      }, '');
    } catch {
      // Native links and disclosures still work when history state is unavailable.
    }
  }

  function restoreNotes() {
    const saved = history.state?.[stateKey];
    if (!Array.isArray(saved)) return;
    const openIds = new Set(saved.filter(id => typeof id === 'string'));
    for (const note of notes) note.open = openIds.has(note.id);
  }

  // Restore before the browser restores its scroll position on a history navigation.
  restoreNotes();
  rememberNotes();
  for (const note of notes) note.addEventListener('toggle', rememberNotes);
  window.addEventListener('pagehide', rememberNotes);
  window.addEventListener('pageshow', restoreNotes);
  window.addEventListener('popstate', restoreNotes);
  window.addEventListener('hashchange', rememberNotes);
})();
